import { WeekdayFresh } from "../common/WeekdayFresh"
import {
  AllBookableServiceSlots,
  BookableServiceSlotsOverride,
} from "./bookable-service-slots"

function jsDayToWeekdayFresh(jsDay: number): WeekdayFresh {
  switch (jsDay) {
    case 0:
      return WeekdayFresh.SUNDAY
    case 1:
      return WeekdayFresh.MONDAY
    case 2:
      return WeekdayFresh.TUESDAY
    case 3:
      return WeekdayFresh.WEDNESDAY
    case 4:
      return WeekdayFresh.THURSDAY
    case 5:
      return WeekdayFresh.FRIDAY
    case 6:
      return WeekdayFresh.SATURDAY
    default:
      throw new Error(`Invalid JS day: ${jsDay}`)
  }
}

export function isSameYmd(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  )
}

export function getDayCapacity(args: {
  date: Date
  weeklySlots: AllBookableServiceSlots
  overrides: BookableServiceSlotsOverride[]
}): number {
  const override = args.overrides.find((o) =>
    isSameYmd(new Date(o.date), args.date),
  )
  if (override) return override.slots

  const weekday = jsDayToWeekdayFresh(args.date.getDay())
  return args.weeklySlots[weekday]
}
